import { gql } from '@apollo/client'
import { BodyText, Heading } from '@farol-ds/react'
import { Image } from '@jusbrasil-web/shared-next-image'

import { LinkedAccountLockContent_OfferLockDataFragment } from './__generated__/content.graphql'
import styles from './linked-account-lock.module.scss'

interface ContentProps {
  offerLockData: LinkedAccountLockContent_OfferLockDataFragment
}
export function Content({ offerLockData }: ContentProps) {
  if (!offerLockData.body.cards.length) {
    return null
  }

  const { body, header } = offerLockData
  const [card] = body.cards

  const { src, alt } = card.image
  const { title } = header
  const [description] = card.descriptions

  return (
    <>
      {src && <Image className={styles.image} alt={alt} src={src} width={160} height={160} />}
      <Heading className={styles.description} size="md" asChild>
        <h3>{title}</h3>
      </Heading>
      <BodyText size="lg">
        <span dangerouslySetInnerHTML={{ __html: description }} />
      </BodyText>
    </>
  )
}

Content.fragments = {
  offerLockData: gql`
    fragment LinkedAccountLockContent_offerLockData on OfferLockData {
      header {
        title
      }
      body {
        cards {
          descriptions
          image {
            alt
            src
          }
        }
      }
    }
  `,
}
